<template>
  <f7-page>
    <f7-navbar>
      <f7-nav-left>
        <f7-link icon-if-ios="f7:menu" icon-if-md="material:menu" panel-open="left"></f7-link>
      </f7-nav-left>
      <f7-nav-title>員工管理</f7-nav-title>
    </f7-navbar>

    <f7-card>
      <f7-card-header class="no-hairline" style="top: 10px;">加入員工</f7-card-header>
      <f7-card-content class="no-hairline">
        <f7-list form>
          <f7-list-item>
            <f7-label floating>員工帳號 (Email)</f7-label>
            <!-- <f7-input type="text" @input="v => employeeToBeAdded = v"/> -->
            <f7-input type="text" :value="employeeToBeAdded" @input="employeeToBeAdded = $event.target.value" />
          </f7-list-item>
        </f7-list>
      </f7-card-content>
      <f7-card-footer class="no-hairline">
        <div style="width: 100%; text-align: right;">
          <f7-button raised fill @click="setUserAsEmployeeOnClick()" style="display: inline-block;">加入</f7-button>
        </div>
      </f7-card-footer>
    </f7-card>

    <f7-list media-list>
      <f7-list-item group-title title="員工列表" />
      <f7-list-item
        v-for="(employee, index) in employees"
        :key="`employee-${index}`"
        :link="`/stores/${storeId}/employee-permissions/${employee.uid}`">
        <span slot="title">{{ employee.email }} ({{ employee.displayName }})</span>
        <font-awesome-icon icon="edit" slot="after" />
      </f7-list-item>
      <f7-list-item group-title title="目前連線中" />
      <f7-list-item
        v-for="(client, index) in currentStoreConnectionClients"
        :key="`current-store-connection-clients-${index}`"
        :subtitle="``">
        <client-information :socketId="socketId" :client="client" slot="inner" style="font-size: 12px;" />
      </f7-list-item>
    </f7-list>
  </f7-page>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import ClientInformation from '../components/ClientInformation'

export default {
  data () {
    return {
      employeeToBeAdded: ''
    }
  },
  props: {
    storeIdProp: String
  },
  computed: {
    ...mapState(['socketId']),
    ...mapState('managerModule', ['employees', 'currentStoreConnectionClients']),
    ...mapGetters(['storeId'])
  },
  async created () {
    await this.setStore(this.storeIdProp)
    if (this.storeId) {
      this.getAllEmployees()
    }
  },
  watch: {
    storeId (v) {
      this.getAllEmployees()
    }
  },
  methods: {
    ...mapActions(['setStore']),
    ...mapActions('managerModule', ['getAllEmployees', 'setUserAsEmployee']),
    setUserAsEmployeeOnClick () {
      this.setUserAsEmployee(this.employeeToBeAdded)
      this.employeeToBeAdded = ''
    }
  },
  components: {
    ClientInformation
  }
}
</script>
